import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserCircle,
  faSignOutAlt,
  faPeopleArrows
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '@BUP/hooks';

const Menu = ({ closeMenu }) => {
  const { user, signOut } = useAuth();
  const isNoOrganization = useRouteMatch("/no-organization");
  
  return ( 
    <div className="menu-wrapper">
      <div className="menu-content">
        <div className="menu-grid">
          <div className="item-wrapper">
            <div className="name-wrapper">
              { user?.name || "Sin Nombre"} 
            </div>
            <div className="rol-wrapper">
              { user?.organizations?.name || "Sin Organización" }
            </div>
          </div>
          <div className="item-wrapper" style={{ border: 0 }}>
            {
              !isNoOrganization ? 
              (
                <Link 
                  to="/profile" 
                  style={{ textDecoration: 'none' }}
                  onClick={closeMenu}
                >
                  <div className="perfil-wrapper select-option">
                    <FontAwesomeIcon
                      className="menu-icon"
                      icon={faUserCircle}
                    />
                    <p>PERFIL</p>
                  </div>
                </Link>
              ) : null
            }
            <div
              className="logout-wrapper select-option"
              onClick={signOut}
            >
              <FontAwesomeIcon
                className="menu-icon"
                icon={faSignOutAlt}
              />
              <p>CERRAR SESIÓN</p>
            </div>
          </div>
          {/*<div className="item-wrapper last-item">
            <div
              className="perfil-wrapper select-option"
              onClick={() => console.log("Change session")}
            >
              <FontAwesomeIcon
                className="menu-icon"
                icon={faPeopleArrows}
              />
              <p>INICIAR SESIÓN COMO APODERADO</p>

            </div>
          </div>*/}
        </div>
      </div>
    </div>
  )
}

export default Menu;